module.exports = __webpack_public_path__ + "img/Station Area Types 2.b08e0814.jpg";